import { render } from "./enrolmentStep2.vue?vue&type=template&id=9a3f15ce"
import script from "./enrolmentStep2.vue?vue&type=script&lang=js"
export * from "./enrolmentStep2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__